import { Injectable } from '@angular/core';
import { AppStore } from '@app/app.store';
import { EmptyMapState, MapState } from './state.model';

@Injectable({
  providedIn: 'root'
})
export class MapStateService {
  constructor(private appStore: AppStore) {}

  init(id: string): MapState {
    const states: { [key: string]: MapState } = this.appStore.state.mapState;
    if (!states[id]) {
      states[id] = new EmptyMapState(id);
      this.appStore.saveState();
    }

    return states[id];
  }

  get(id: string): MapState {
    const state: MapState = this.appStore.state.mapState[id];
    if (!state) {
      return this.init(id);
    }

    return state;
  }

  clearAndGet(idPrefix: string, id: string): MapState {
    const matchingKey: string = Object.keys(this.appStore.state.mapState).find((key: string) =>
      key.startsWith(idPrefix)
    );

    if (matchingKey !== id) {
      this.delete(matchingKey);
    }

    return this.get(id);
  }

  exists(id: string): boolean {
    return !!this.appStore.state.mapState[id];
  }

  update(state: MapState): void {
    this.appStore.state.mapState[state.id] = state;
    this.appStore.saveState();
  }

  delete(id: string): void {
    delete this.appStore.state.mapState[id];
    this.appStore.saveState();
  }

  clear(): void {
    this.appStore.state.mapState = {};
    this.appStore.saveState();
  }
}
